export default class PackageWrapper {
  // html selector for the component
  static selectorString() {
    return '.js-package-wrapper';
  }

  // rootNode = html element with js-class
  // props = data attribute 'props' to pass down customization
  constructor(rootNode) {
    this.$refs = {
      rootNode,
      bgImg: rootNode.querySelector('.bg-image'),
      packages: [...rootNode.querySelectorAll('.js-package')],
    };

    this.packagesOpened = [];
    this.$refs.bgImg.style.maxHeight = this.$refs.rootNode.scrollHeight + 'px';

    this.setupHandler();
  }

  setupHandler() {
    window.addEventListener('show-package', () => {
      this.packagesOpened.push(1);
      this.$refs.rootNode.classList.add('is-open');
    });

    window.addEventListener('hide-package', () => {
      this.packagesOpened.pop();
      if (this.packagesOpened.length === 0) this.$refs.rootNode.classList.remove('is-open');
    });
  }
}
